<div class="oa-sheet upload-image">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            {{ title }}
            <span class="oa-sheet__subtitle">{{ disabled ? 'Arraste a imagem e use o zoom para enquadrar.' : 'Ideal: ' + resizeToWidth + '×' + resizeToHeight + ' px' }}</span>
        </h2>
        <button type="button" class="oa-icon-btn" [disabled]="loading" (click)="close()" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body upload-image__body">
        <!-- Seleção: clique ou arraste o arquivo (o input cobre a área toda) -->
        <div *ngIf="!disabled" class="upload-image__drop" [class.is-over]="borderBlue"
            (dragover)="allowDrop($event)" (dragleave)="borderBlue = false" (drop)="borderBlue = false">
            <mat-icon class="upload-image__drop-icon">add_photo_alternate</mat-icon>
            <span class="upload-image__drop-title">{{ description }}</span>
            <span class="upload-image__drop-hint">JPEG ou PNG até 5 MB</span>
            <span class="oa-btn oa-btn--secondary oa-btn--sm upload-image__drop-btn">
                <mat-icon>upload</mat-icon>
                Escolher imagem
            </span>
            <input type="file" (change)="fileChangeEvent($event)" aria-label="Escolher imagem"
                accept="image/png,image/jpeg,image/jpg,image/gif,image/svg,image/webp,image/ico" />
        </div>

        <!-- Enquadramento -->
        <ng-container *ngIf="disabled">
            <div class="upload-image__crop" *ngIf="imageUrl">
                <img #imageElement [src]="imageUrl" alt="Imagem para recortar" />
            </div>

            <div class="upload-image__zoom">
                <mat-icon aria-hidden="true">zoom_out</mat-icon>
                <mat-slider min="0.05" max="1" step="0.01" [value]="scale" aria-label="Zoom"
                    (input)="onZoomSliderChange($event.value)"></mat-slider>
                <mat-icon aria-hidden="true">zoom_in</mat-icon>
                <span class="upload-image__zoom-value">{{ (scale * 100) | number:'1.0-0' }}%</span>
            </div>

            <button type="button" class="oa-btn oa-btn--ghost oa-btn--sm upload-image__change" [disabled]="loading"
                (click)="chooseAnother()">
                <mat-icon>swap_horiz</mat-icon>
                Trocar imagem
            </button>
        </ng-container>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" [disabled]="loading" (click)="close()">
            Cancelar
        </button>
        <button type="button" class="oa-btn oa-btn--primary" [disabled]="loading || !disabled" (click)="save()">
            <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!loading">check</mat-icon>
            <span class="oa-btn__label">Salvar</span>
        </button>
    </footer>
</div>
